<template>
  <div class="main-content main-content_vertical">
    <div class="wrapper">
      <div class="h1 h1-mob-lg" v-if="donationWithoutSendingEffect">{{$t('success.thank_you_for_your_donation')}}</div>
      <div class="h1 h1-mob-lg" v-else>{{$t('sent.done')}}</div>
      <div class="btns">
        <router-link to="/" class="black-link" v-if="donationWithoutSendingEffect">{{$t('success.go_back')}}</router-link>
        <router-link to="/" class="black-link" v-else>{{$t('sent.go_back')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  name: "Sent",
  methods: {
    ...mapMutations(['setMode'])
  },
  mounted() {
    this.setMode('sponsor');
  },
  computed: {
    donationWithoutSendingEffect() {
      return this.$store.getters.donationOnlyMode || this.$route.name === 'SentDonationWithoutGeneratedEffect';
    },
  }
};
</script>
